import { render, staticRenderFns } from "./DepartmentalPlanManagement.vue?vue&type=template&id=b67854ec&scoped=true"
import script from "./DepartmentalPlanManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentalPlanManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentalPlanManagement.vue?vue&type=style&index=0&id=b67854ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67854ec",
  null
  
)

export default component.exports